import { combineReducers } from 'redux';
import { errorModuleReducer } from '@ls/error-module';
import app from './app/reducer';
import data from './data/reducer';
import grid from './grid/reducer';
import selection from './selections/reducer';
import analytic from './analytics/reducer';
import tradehistoryAttribute from './tradehistoryAttributes/reducer'
import scopeReducer from './analytics/scope';
import betasScope from "state/betas/scope";
import betasReducer from 'state/betas/reducer';

import holdingAttributesScope from 'state/holdingAttributes/scope';
import holdingnAttributesReducer from 'state/holdingAttributes/reducer';
export default combineReducers({
  app,
  data,
  grid,
  selection,
  tradehistoryAttribute,
  [scopeReducer]: analytic,
  [betasScope]: betasReducer,
  [holdingAttributesScope]: holdingnAttributesReducer,
  ...errorModuleReducer
});
